<template>
  <div class="incomplete-steps">
    <page-status
      v-for="step in steps"
      :key="step.name"
      :name="step.name"
      :status="step.status || 'PENDING'"
      :filled="step.filled"
      @click="$emit('step-click', step.route)"
    />
    <div v-if="steps.length === 0" class="all-complete-message">
      No incomplete steps.
    </div>
  </div>
</template>

<script>
import PageStatus from '@/components/client/PageStatus.vue';

export default {
  name: 'IncompleteStepsList',
  components: { PageStatus },
  props: {
    steps: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
.incomplete-steps {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
}

.all-complete-message {
  text-align: center;
  padding: 16px;
  font-weight: 500;
  color: var(--color-text-secondary);
}
</style> 